import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.S2GU6S4fQTAJpn5PBtORIxp9pGuQOG01rJjhOQrX3VMPVukr7LX1eWDyhYs9JfigfRU6aOfiUmcN5VWIJWmTUeOMLI4zP4t1_PaNLI_FPVMT2pQlDzD1ELelxjHTdO9MNRMZc_o0GBdYct6IcK17C3fFQe3HKRVPrzinwo7w4PHJefTSMx2Xgdz1Bh8T-2xAgRu_7x6CslIChWi_WLikqPH-WkycfYru19pw2HhisZEjD6gF3ng5ZMNkiSHVPuEEN8kDkPq9b-yLCvini_sk6Dt9h_o8NQNPhpI7CWNHrvU5unAc7PIfrS948PT-FPgc3bwhlIbS6eNnV0mP7Vhh_43WDwK0vBmRZg",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-10-21T15:24:50.619612Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.S2GU6S4fQTAJpn5PBtORIxp9pGuQOG01rJjhOQrX3VMPVukr7LX1eWDyhYs9JfigfRU6aOfiUmcN5VWIJWmTUeOMLI4zP4t1_PaNLI_FPVMT2pQlDzD1ELelxjHTdO9MNRMZc_o0GBdYct6IcK17C3fFQe3HKRVPrzinwo7w4PHJefTSMx2Xgdz1Bh8T-2xAgRu_7x6CslIChWi_WLikqPH-WkycfYru19pw2HhisZEjD6gF3ng5ZMNkiSHVPuEEN8kDkPq9b-yLCvini_sk6Dt9h_o8NQNPhpI7CWNHrvU5unAc7PIfrS948PT-FPgc3bwhlIbS6eNnV0mP7Vhh_43WDwK0vBmRZg'

// {
//   "access_token": "v2.local.VOkmCT05S1wMrVILJ3LhcaJsVmMGsIUMfyRWKtvdhhWB3P_xwepveST1-NTsnGX--txZVZiob86-BzBzLOCUQ_wJYYNu0btB0lFMRj_vLi0njqZfgoOo-XbVaKh19d-tsr1HyQA8inwhtt_1MGZ9rANC2aZjxOnoKRwOUSB9c5IgsrLPseiQej_5zKP1lMtMNiXUefiMoxgWcjHMsoL_SCMiNDT_NQ2OupSx9EJMWEPaOOgoiPDu3hHe7eX56KJNc4UFTOM9O91hRzn76weWrKa3WBdQItE4zd67XKDpehCP6j-1OwfdYjkwIqqtKUpZrBUi2chD5SP0_tbY18MlrNC8H6PJ",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-10-21T15:24:50.925566Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.VOkmCT05S1wMrVILJ3LhcaJsVmMGsIUMfyRWKtvdhhWB3P_xwepveST1-NTsnGX--txZVZiob86-BzBzLOCUQ_wJYYNu0btB0lFMRj_vLi0njqZfgoOo-XbVaKh19d-tsr1HyQA8inwhtt_1MGZ9rANC2aZjxOnoKRwOUSB9c5IgsrLPseiQej_5zKP1lMtMNiXUefiMoxgWcjHMsoL_SCMiNDT_NQ2OupSx9EJMWEPaOOgoiPDu3hHe7eX56KJNc4UFTOM9O91hRzn76weWrKa3WBdQItE4zd67XKDpehCP6j-1OwfdYjkwIqqtKUpZrBUi2chD5SP0_tbY18MlrNC8H6PJ'

// {
//   "access_token": "v2.local.rHuNfCzw5xNsx5a-q4mki5bbE1JGeYpHFGSGR_ejAODSYFzBZrSsc6aTza8jKcnAoM8hw9DAgWyrcWzXLMgWaUo53yXCg23KWwPgwUwbSnj5btRhtyY8RvCzPwFPwVoy_m3E3bhMRgZQU9cPqZxABWlE6ZXX7JsLJixDt2HT_P4m_tNvviPW6tHGi8W5HQfdyOsGhgNrr3Y5nux_QrvN5hvgC8_Uq6lPRcaCfga0pAbl7F_oxo1Gr6y_SyJZ_6I67RK0_Eyd-c5lnOeV7Bp9qeq8_jFbwjf9Rn-TNmTz5LnuEDtIh8N2fLX5us1A6qhoLymqj2nvBTQGH3CdLAP9m1QvllQ",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-10-21T15:24:51.283441Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.rHuNfCzw5xNsx5a-q4mki5bbE1JGeYpHFGSGR_ejAODSYFzBZrSsc6aTza8jKcnAoM8hw9DAgWyrcWzXLMgWaUo53yXCg23KWwPgwUwbSnj5btRhtyY8RvCzPwFPwVoy_m3E3bhMRgZQU9cPqZxABWlE6ZXX7JsLJixDt2HT_P4m_tNvviPW6tHGi8W5HQfdyOsGhgNrr3Y5nux_QrvN5hvgC8_Uq6lPRcaCfga0pAbl7F_oxo1Gr6y_SyJZ_6I67RK0_Eyd-c5lnOeV7Bp9qeq8_jFbwjf9Rn-TNmTz5LnuEDtIh8N2fLX5us1A6qhoLymqj2nvBTQGH3CdLAP9m1QvllQ'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
